// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const snorunt: PokeData = {
  "id": 361,
  "name": "snorunt",
  "height": 7,
  "weight": 168,
  "base_experience": 60,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "headbutt",
    "leer",
    "bite",
    "ice-beam",
    "blizzard",
    "double-team",
    "powder-snow",
    "protect",
    "icy-wind",
    "crunch",
    "hail",
    "astonish",
    "weather-ball",
    "ice-shard",
    "ice-fang",
    "frost-breath",
    "icicle-crash",
    "snowscape"
  ],
  "moves": [
    "headbutt",
    "leer",
    "bite",
    "blizzard",
    "protect",
    "crunch",
    "ice-shard",
    "ice-fang",
    "icicle-dagger",
    "sheer-cold",
    "hailstorm",
    "chilly-reception",
    "ice-punch"
  ],
  "evolution_chain": {
    "id": 186,
    "item": null,
    "species": [
      {
        "name": "snorunt",
        "order": 390,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "glalie",
        "order": 391,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 361,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "froslass",
        "order": 392,
        "types": [
          PokeType.ICE,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 361,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "dawn-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": {
              "name": "female"
            }
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 50,
    "speed": 50,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
